const TOAST_TYPES = {
    topRight: 'b-toaster-top-right',
    topLeft: 'b-toaster-top-left',
    topCenter: 'b-toaster-top-center',
    topFull: 'b-toaster-top-full',
    bottomRight: 'b-toaster-bottom-right',
    bottomLeft: 'b-toaster-bottom-left',
    bottomCenter: 'b-toaster-bottom-center',
    bottomFull: 'b-toaster-bottom-full',
    layoutToaster: 'layout-toaster',
};

export const TOAST_ICON_TYPES = {
    SUCCESS : 'success',
    ERROR: 'error',
    TRASH: 'trash'
};

export default {
    methods: {
        showNotification(options, persistRouteChange = true) {
            let toaster = 'b-toaster-bottom-left';
            if (document.querySelector('.menu-left-sidebar') && !document.querySelector('.modal-backdrop')) {
                toaster = 'layout-toaster';
            }

            const $bvToast = persistRouteChange ?
                this.$root.$bvToast : this.$bvToast;

            let vNodesMsg;
            if (typeof options.message === "object") {
                vNodesMsg = options.message;
                vNodesMsg.data.class.push('font-weight-bold', 'text-white', 'mx-2');
            } else {
                const h = this.$createElement;
                let icon = options.customIcon || '';
                let message = [h(
                    'span',
                    {
                        class: ['font-weight-bold', 'align-bottom', 'mx-2'],
                        style: ['font-size: 1rem'],
                    },
                    [
                        options.message,
                    ])];

                if (
                    !icon &&
                    options.type &&
                    Object.values(TOAST_ICON_TYPES).includes(options.type)
                ) {
                    switch (options.type) {
                        case TOAST_ICON_TYPES.SUCCESS:
                            icon = 'far fa-check';
                            break;
                        case TOAST_ICON_TYPES.ERROR:
                            icon = 'far fa-times';
                            break;
                        case TOAST_ICON_TYPES.TRASH:
                            icon = 'far fa-trash-alt';
                            break;
                    }

                }

                if (icon) {
                    const img = h('i', {
                        class: [icon , 'mx-2', 'align-middle'],
                        style: 'font-size: 1.5rem',
                    });
                    message.unshift(img);
                }

                vNodesMsg = [h(
                    'div',
                    {class: ['text-white']},
                    message
                )];
            }

            if(options.toaster && TOAST_TYPES.hasOwnProperty(options.toaster)) {
                toaster = TOAST_TYPES[options.toaster];
            }

            let toastClass = ['p-1', 'd-inline-block', ...(options.toastClasses ? options.toastClasses : [])];

            $bvToast.toast(vNodesMsg, {
                autoHideDelay: 3000,
                solid: true,
                variant: 'indigo',
                toaster: toaster,
                noCloseButton: true,
                toastClass: toastClass,
            });
        },

        showErrorToast(message) {
            this.showNotification({
                type: TOAST_ICON_TYPES.ERROR,
                message,
            });
        },
    },
};
